import SkeletonHOC from '../SkeletonHOC'

const FieldSkeleton = SkeletonHOC({ width: 100, height: 50 })

export default FieldSkeleton
